import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import * as React from "react";
import { useContext } from "react";

interface SVGProps extends React.SVGProps<SVGSVGElement> {}

const ContactsIcon: React.FC<SVGProps> = (props) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalColor = props?.fill?.trim() ? props?.fill?.trim() : isDarkMode ? "#FFFFFF" : "#00132E";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: finalColor }}
      {...props}
    >
      <g clipPath="url(#clip0_24902_47810)">
        <path
          d="M13.929 1.57813C14.1838 1.57813 14.4222 1.72016 14.5518 1.94833L16.4419 5.28475C16.5753 5.52015 16.5753 5.8121 16.4419 6.04751L14.5518 9.38393C14.4222 9.6121 14.1838 9.75413 13.929 9.75413H10.0698C9.81492 9.75413 9.57652 9.6121 9.44689 9.38393L7.55682 6.04751C7.42339 5.8121 7.42339 5.51949 7.55682 5.28475L9.44689 1.94833C9.57652 1.72016 9.81492 1.57813 10.0698 1.57813H13.929ZM13.929 0H10.0698C9.27616 0 8.54201 0.436615 8.13921 1.14743L6.24913 4.48385C5.83558 5.21373 5.83558 6.11918 6.24913 6.84906L8.13921 10.1855C8.54201 10.8963 9.27616 11.3329 10.0698 11.3329H13.929C14.7225 11.3329 15.4567 10.8963 15.8595 10.1855L17.7496 6.84906C18.1631 6.11918 18.1631 5.21373 17.7496 4.48385L15.8595 1.14743C15.4567 0.436615 14.7225 0 13.929 0Z"
          fill="currentColor"
        />
        <path
          d="M11.9997 15.5791C14.5544 15.5791 17.0288 16.311 18.9663 17.6399C20.7773 18.882 22.0186 20.5739 22.4682 22.4091C22.4524 22.4157 22.4296 22.4216 22.398 22.4216H1.60145C1.5692 22.4216 1.54644 22.4157 1.53126 22.4091C1.98086 20.5732 3.22215 18.882 5.03319 17.6399C6.97069 16.311 9.44442 15.5791 11.9997 15.5791ZM11.9997 14.001C6.06264 14.001 1.11834 17.4893 0.0401951 22.1053C-0.186184 23.0752 0.571997 23.9991 1.60209 23.9991H22.398C23.4281 23.9991 24.1863 23.0752 23.9599 22.1053C22.8817 17.4886 17.9374 14.001 12.0004 14.001H11.9997Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default ContactsIcon;
